import ChangePassword from "./Subpages/ChangePassword/ChangePassword";
import Profil from "./Subpages/Profil/Profil";
import ChangeEmail from "./Subpages/ChangeEmail/ChangeEmail";

const Settings = {

    init() {

        this.el = $('[page="Settings"]');

        if ( !this.el.length ) {
            return;
        }

        this.start();
    },

    start() {
        Profil.init();
        ChangePassword.init();
        ChangeEmail.init();
    }
}
export default Settings;